import React, { useEffect, useState } from "react";
import "../css/Wins.css";
import secureLocalStorage from "react-secure-storage";
import { getWeeklyTaskProgress } from "../Api";
import confetti from "canvas-confetti"; // 🎆 引入烟花动画库
import { FaSpinner } from "react-icons/fa";

const Wins = ({ tasks = [], isPreventive }) => {
  // Default to an empty array if tasks is undefined
  const [completedCount, setCompletedCount] = useState(0);
  const [checkedTasks, setCheckedTasks] = useState({});
  const [shakingTasks, setShakingTasks] = useState({}); // 用于存储晃动状态
  const [hiddenTasks, setHiddenTasks] = useState({}); // 🎯 控制 checkbox 是否隐藏
  const [progress, setProgress] = useState(0); // 🎯 进度条值

  useEffect(() => {
    // 初始化 checked 状态
    let newProgress = 0;
    if (Array.isArray(tasks) && tasks.length > 0) {
      const completedCountTask = tasks.filter((task) => task.completed).length;
      setCompletedCount(completedCountTask);
      newProgress = (completedCountTask / tasks.length) * 100;
    }
    setProgress(newProgress);

    const initialCheckedState = tasks.reduce((acc, task) => {
      acc[task.id] = task.completed;
      return acc;
    }, {});
    setCheckedTasks(initialCheckedState);
  }, [tasks]);

  const getPatientId = () => secureLocalStorage.getItem("patient_id");

  const handleCheckboxChange = async (task_id, checked, event) => {
    try {
      const newCheckedState = !checkedTasks[task_id]; // Toggle checked state
      setCheckedTasks((prev) => ({
        ...prev,
        [task_id]: newCheckedState,
      }));
      setHiddenTasks((prev) => ({
        ...prev,
        [task_id]: true,
      }));

      // Add shaking effect
      setShakingTasks((prev) => ({
        ...prev,
        [task_id]: true, // Mark task as shaking
      }));

      // Remove shaking after 300ms
      setTimeout(() => {
        setShakingTasks((prev) => ({
          ...prev,
          [task_id]: false,
        }));
      }, 300);

      const patient_id = getPatientId();
      const progressData = await getWeeklyTaskProgress(
        patient_id,
        task_id,
        isPreventive,
        newCheckedState
      );

      // Ensure spinner is hidden after progressData is fetched
      setHiddenTasks((prev) => ({
        ...prev,
        [task_id]: false,
      }));

      // Calculate updated completed count (corrected part)
      const updatedCompletedCount =
        Object.values(checkedTasks).filter(Boolean).length +
        (newCheckedState ? 1 : -1);
      const updatedProgress = (updatedCompletedCount / tasks.length) * 100;

      setCompletedCount(updatedCompletedCount);
      setProgress(updatedProgress);

      if (newCheckedState === true) {
        const checkbox = event.target;
        const { top, left, width, height } = checkbox.getBoundingClientRect();

        const x = left + width / 2;
        const y = top + height / 2;
        if (updatedProgress === 100) {
          triggerFireworks(x, y);
        }
      }
    } catch (error) {
      console.error("Error updating task:", error);
      // Ensure spinner is hidden in case of error
      setHiddenTasks((prev) => ({
        ...prev,
        [task_id]: false,
      }));
    }
  };

  // 🎆 触发烟花效果
  const triggerFireworks = (x, y) => {
    confetti({
      particleCount: 100,
      spread: 70,
      origin: { y: 0.6 }, // 让烟花从页面中心偏上位置释放
    });
  };

  return (
    <section className="wins-section">
      <div className="section-container">
        <div className="left">
          <h3>Your Wins This Week</h3>
        </div>
        <div className="right">
          <p>
            {completedCount} of {tasks.length} Completed
          </p>
        </div>
      </div>
      <div className="task-progress-container">
        <div
          className="task-progress-bar"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <div className="wins-list">
        <ul>
          {tasks.map((task) => (
            <li key={task.id} className={shakingTasks[task.id] ? "shake" : ""}>
              {hiddenTasks[task.id] ? (
                <FaSpinner className="spinner" /> // 🔄 显示加载动画
              ) : (
                <input
                  className="left"
                  type="checkbox"
                  onChange={(event) =>
                    handleCheckboxChange(task.id, !task.completed, event)
                  }
                  checked={checkedTasks[task.id] || false}
                />
              )}

              <label>
                <strong>{task.title} </strong> - {task.description}
              </label>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default Wins;
